import React from "react";
import { observer } from "mobx-react";
import { AlertRuleViewStore } from "../../store";
import { AlertRuleViewForm } from "./AlertRuleViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AlertRuleViewProps = {
  alertRuleViewStore: AlertRuleViewStore;
};

export const AlertRuleView: React.FC<AlertRuleViewProps> = observer(
  ({ alertRuleViewStore }) => {
    return (
      <div>
        <AlertRuleViewForm
          alertType={alertRuleViewStore.alertTypeValue}
          enabled={alertRuleViewStore.enabledValue}
          params={alertRuleViewStore.paramsValue}
          onPrint={(handlePrint: () => void) =>
            alertRuleViewStore.printAlertRule(handlePrint)
          }
          onCancel={() => alertRuleViewStore.cancelAlertRule()}
          onEdit={
            alertRuleViewStore.isEditEnabled
              ? () => alertRuleViewStore.editAlertRule()
              : undefined
          }
        />
        <ErrorDialog
          open={alertRuleViewStore.errorDialogOpened}
          title={alertRuleViewStore.errorTitle}
          description={alertRuleViewStore.errorDescription}
          onClose={() => alertRuleViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
